import { useInformationList } from "@/api/services/admin/information";
import { Button } from "@/modules/irohana-components/elements/Button";
import { CountTable } from "@/modules/irohana-components/elements/CountTable";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";

type TInformationListTopProps = {};

export const InformationListTop: FC<TInformationListTopProps> = () => {
  const { data } = useInformationList();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <CountTable total={data?.pagination.total} page={data?.pagination.page} perPage={data?.pagination.perPage} />
      <Button component={Link} to={AppRoutes.informationCreate}>
        新規作成
      </Button>
    </Stack>
  );
};
